export default {
  computed: {
    allClientsFakeSegment() {
      return { id: 0, name: I18n.t('segments.modal.all_companies') }
    },
  },
  methods: {
    selectAllClients() {
      if (this.segment) {
        this.unselectSegment()
      }
    },
  },
}
